import {Link} from "react-router-dom"
import { FiAlertTriangle, FiEdit, FiUser, FiHome, FiSearch } from "react-icons/fi"
import { auth } from '../functions/firebaseFunctions';
export default function HeaderLink(props) {
    const {pageName,link,linkName,mobile,setIsMobNavOpen, hasNewMessages} = props
    console.log('hasNewMessages props', hasNewMessages)
    return(
        <li
        onClick={()=>{if(mobile){setIsMobNavOpen(false)}}}>
            <Link to={link} className={
                linkName === "Profile" && pageName === linkName && hasNewMessages === true
                    ? "HeaderLinkSelected HeaderLink HeaderLinkNotification" 
                    : linkName === "Profile" && hasNewMessages === true
                    ? "HeaderLinkSelected HeaderLink HeaderLinkNotification"
                    : pageName === linkName
                    ? "HeaderLinkSelected HeaderLink"
                    : "HeaderLink"
                }>
                <div style={{}}>{
                linkName === 'Profile' ? (auth.currentUser ? 
                    <img alt='Profile_pitcture' src={auth.currentUser.photoURL ? auth.currentUser.photoURL : '/blank-profile-picture.png'} style={{objectFit: 'cover', borderRadius: '50%', width: 30, height: 30}}/>  : <FiUser />) :
                linkName === 'BugReport' ? <FiAlertTriangle /> :
                linkName === 'Browse' ? <FiSearch /> :
                linkName === 'Home' && <FiHome /> 
                }
                </div>
                <p style={mobile && {width: '75px'}}>{linkName}</p>
            </Link>
        </li>
    )
}